var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-box"},[_c('div',{staticClass:"post-content text-left"},[_c('h6',{staticClass:"post-title"},[_vm._v("\n            Live Casino\n        ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'LiveCasino'}}},[_c('img',{attrs:{"width":"100%","src":"/static/assets/img/rivalo/masonryBigThumbnail.jpeg"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b0b813d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/widget/liveCasinoBanner.vue
// module id = wJf0
// module chunks = 0